import axios from 'axios';

// const API = axios.create({ baseURL: 'http://localhost:5000' })
const API = axios.create({ baseURL: 'https://sanme-portfolio-c47c6ed45f5f.herokuapp.com' })

//This is going to be a function that's going to happen on each one of our request
API.interceptors.request.use((req) => {
    if(localStorage.getItem('authData')){
        req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('authData')).token}`
    }
    return req
})

const posts       = '/posts'
const contactUs   = '/contact-us'


//posts
export const fetchAllPosts         =  API.get(`${posts}/all`)

//contact us
export const createContactUsMessage = (formData) => API.post(`${contactUs}/create`, formData)